import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { CatalogService, ProfileService, SweetAlertService } from '../../../services/index'
import { QuestionsBussinesModel } from 'src/app/models/profile/profile.model'
import { FormGroup, FormBuilder, FormControl, FormArray, Validators } from '@angular/forms'
import { TypeSweet } from '../../../utils/typeSweet'
import { catchError, switchMap, tap } from 'rxjs/operators'
import { EMPTY } from 'rxjs'
declare const fbq: any

@Component({
  selector: 'app-modal-survey',
  templateUrl: './modal-survey.component.html',
  styleUrls: ['./modal-survey.component.scss']
})
export class ModalSurveyComponent implements OnInit {
  @ViewChild('videoInit') content: ElementRef
  arrayBusinessImprovements: QuestionsBussinesModel[] = []
  formSurvey: FormGroup
  isDisabled: boolean = true
  businessDigitalSurveyForm: FormGroup;
  public surveyScaleOptions = [
    { value: 1, label: '1 - Nulo conocimiento' },
    { value: 2, label: '2 - Poco conocimiento' },
    { value: 3, label: '3 - Conocimiento moderado' },
    { value: 4, label: '4 - Buen conocimiento' },
    { value: 5, label: '5 - Muy alto conocimiento' }
  ];

  constructor (
    public activeModal: NgbActiveModal,
    private readonly fb: FormBuilder,
    private readonly sweetAlert: SweetAlertService,
    public _catalogService: CatalogService,
    private readonly _profileService: ProfileService
  ) {}

  ngOnInit (): void {
    this.loadForm()
  }

  async ngAfterViewInit (): Promise<void> {
    if (this.content !== undefined) {
      const element = this.content.nativeElement as HTMLVideoElement
      element.muted = true
      element.muted = false
      await element.play()
    }
  }

  loadForm () {
    this.formSurvey = this.fb.group({
      business_improvements: this.fb.array([]),
      business_improvements_modal: new FormControl('')
    })

    this.businessDigitalSurveyForm = this.fb.group({
      business_confidence: [null, Validators.required],
      financial_knowledge: [null, Validators.required],
      uses_digital_tool: [null, Validators.required],
      uses_digital_control: [null, Validators.required],
      uses_payment_methods: [null, Validators.required],
    })
  }

  loadBusinessImprovements () {
    this._catalogService.getBusinessImprovements()
      .subscribe(res => {
        this.arrayBusinessImprovements = res
      })
  }

  closeModal(){
    this.formSurvey.get('business_improvements_modal').setValue(true);

    this._profileService.patchBusinesslData(this.formSurvey.value).subscribe(
      res =>
      {
        fbq('track', 'CompleteRegistration');
        this.activeModal.dismiss();
      }
      , error => {
        this.sweetAlert.basicSweet('Error', 'Por favor, vuelve a intentarlo', TypeSweet.error)
      }
    )
  }

  submitSurvey() {
    if (this.businessDigitalSurveyForm.invalid) {
      this.sweetAlert.basicSweet(
        'Error',
        'Por favor, completa todos los campos requeridos',
        TypeSweet.error
      );
      return;
    }

    this.formSurvey.get('business_improvements_modal').setValue(true);

    this._profileService
      .patchBusinesslData(this.formSurvey.value)
      .pipe(
        switchMap(() =>
          this._profileService.sendBusinessSurvey(this.businessDigitalSurveyForm.value)
        ),
        tap(() => {
          fbq('track', 'CompleteRegistration');
          this.sweetAlert.basicSweet(
            'Guardado',
            'Datos guardados exitosamente',
            TypeSweet.success
          );
          this.activeModal.close();
        }),
        catchError((error) => {
          this.sweetAlert.basicSweet(
            'Error',
            'Por favor, vuelve a intentarlo',
            TypeSweet.error
          );
          return EMPTY;
        })
      )
      .subscribe();
  }
}
